import { render, staticRenderFns } from "./LoginPageLayout.vue?vue&type=template&id=338b14b2&scoped=true&"
import script from "./LoginPageLayout.vue?vue&type=script&lang=ts&"
export * from "./LoginPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPageLayout.vue?vue&type=style&index=0&id=338b14b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b14b2",
  null
  
)

export default component.exports